import { UseFormReturnType } from "@mantine/form";

export type QuestionnaireFormWithEditFlag<T> = UseFormReturnType<T> & {
  isEditingQuestionnaire?: boolean;
};

/**
 * Marks a Mantine questionnaire form so timer and related fields use edit-mode behavior.
 */
export function markQuestionnaireFormAsEditing<T>(form: UseFormReturnType<T> | undefined): void {
  if (!form) {
    return;
  }
  (form as QuestionnaireFormWithEditFlag<T>).isEditingQuestionnaire = true;
}
